const OrangeCircleIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
    >
      <circle cx='7' cy='7' r='7' fill='#F8FCFF' />
      <circle cx='7' cy='7' r='6' fill='#FF910A' />
    </svg>
  );
};

OrangeCircleIcon.displayName = 'OrangeCircleIcon';

export default OrangeCircleIcon;
